import { createSlice } from "@reduxjs/toolkit";

const imagingStudySlice = createSlice({
    name: "imagingStudies",
    initialState: {},
    reducers: {
        registerImagingStudy: (state, action) => {
            const study = action.payload;
            if (!study?.id) return;

            if (!state[study.id]) {
                state[study.id] = study;
            } else {
                console.warn(
                    `⚠️ ImagingStudy ${study.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterImagingStudies: (state, action) => {
            action.payload.forEach((study) => {
                if (!study?.id) return;

                if (!state[study.id]) {
                    state[study.id] = study;
                } else {
                    console.warn(
                        `⚠️ ImagingStudy ${study.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerImagingStudy,
    bulkRegisterImagingStudies
} = imagingStudySlice.actions;

export default imagingStudySlice.reducer;
